import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Flex } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled, { keyframes } from "styled-components";
const shimmer = keyframes`
  0% {
    opacity: 0.25;
  }

  100% {
    opacity: 1;
  }
`;
const ShimmerBox = styled(Box)`
  animation-name: ${shimmer};
  animation-duration: 1s;
  opacity: 0.25;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: steps(10, end);
  background: ${themeGet("colors.white.12")};
`;
const MoveItemsDialogLoader = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                mx: "8px",
                pb: "32px",
                children: [
                    /*#__PURE__*/ _jsx(ShimmerBox, {
                        mb: "8px",
                        height: "12px",
                        width: "30%"
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        height: "40px",
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "24px",
                                width: "24px"
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                mx: "16px",
                                height: "16px",
                                width: "70%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        height: "40px",
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "24px",
                                width: "24px"
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                mx: "16px",
                                height: "16px",
                                width: "40%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        height: "40px",
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "24px",
                                width: "24px"
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                mx: "16px",
                                height: "16px",
                                width: "70%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Box, {
                mx: "8px",
                pb: "32px",
                children: [
                    /*#__PURE__*/ _jsx(ShimmerBox, {
                        mb: "8px",
                        height: "12px",
                        width: "30%"
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        height: "40px",
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "24px",
                                width: "24px"
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                mx: "16px",
                                height: "16px",
                                width: "70%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        height: "40px",
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "24px",
                                width: "24px"
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                mx: "16px",
                                height: "16px",
                                width: "50%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        height: "40px",
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "24px",
                                width: "24px"
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                mx: "16px",
                                height: "16px",
                                width: "70%"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default MoveItemsDialogLoader;
